// Import the mixin directly without initializing the package's UI plugins.
import { aiGenerationMixin } from '@cglt/ui-legacy/src/mixins/aiGenerationMixin.js'
import { ajaxTokenSource, createAIClient, tokenTransport } from '@cglt/ai/client'

// One client per Vuex store (that is, per app), so every component shares the cached AI token.
const clientsByStore = new WeakMap()

function clientForComponent(component) {
	const store = component.$store
	let client = clientsByStore.get(store)

	if (!client) {
		const getToken = ajaxTokenSource(
			// Look U up per call: importing this module must not touch browser globals.
			(service, params) => U.ajax_promise(service, params),
			// Read identity per request so a login or user change never reuses another user's token.
			{ params: () => ({ user_id: store.state.user_info.user_id }) },
		)

		client = createAIClient({ transport: tokenTransport({ getToken }) })
		clientsByStore.set(store, client)
	}

	return client
}

// The shared mixin creates a client in created(), once the component exists.
// Importing this module does not read U or the store, or send a request.
const CureumAIGenerationMixin = aiGenerationMixin({
	client: clientForComponent,
})

export default CureumAIGenerationMixin
